import { apiService } from '@/services/APIService';

export default {

  getAll(params) {
    return apiService.get('/notifications', params);
  },

  read(id, params) {
    return apiService.post(`/notifications/${id}/change-read`, params);
  },

};
